import React from "react";
import { interpolate, useCurrentFrame } from "remotion";

export const SportsBackground: React.FC = () => {
  const frame = useCurrentFrame();

  // 6 animated speed lines moving right-to-left, cycling every 45 frames
  const speedLines = [
    { y: 180, width: 80, opacity: 0.28 },
    { y: 340, width: 120, opacity: 0.22 },
    { y: 520, width: 60, opacity: 0.3 },
    { y: 710, width: 100, opacity: 0.25 },
    { y: 880, width: 45, opacity: 0.2 },
    { y: 1060, width: 90, opacity: 0.26 },
  ];

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#0a0a0a",
        overflow: "hidden",
      }}
    >
      {/* Diagonal slash panel — right side slanted stripe */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "55%",
          height: "100%",
          backgroundColor: "#1a1a1a",
          clipPath: "polygon(18% 0%, 100% 0%, 100% 100%, 0% 100%)",
          zIndex: 0,
        }}
      />

      {/* Second diagonal slash — inner accent stripe */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "40%",
          height: "100%",
          backgroundColor: "#141414",
          clipPath: "polygon(22% 0%, 100% 0%, 100% 100%, 4% 100%)",
          zIndex: 1,
        }}
      />

      {/* Orange triangle flash — top-left corner accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(135deg, rgba(255,107,0,0.15) 0%, transparent 50%)",
          clipPath: "polygon(0 0, 40% 0, 0 60%)",
          zIndex: 2,
        }}
      />

      {/* Animated speed lines */}
      {speedLines.map((line, i) => {
        // Each line has a slightly offset phase so they don't all move in sync
        const offset = i * 7;
        const cycleFrame = (frame + offset) % 45;
        const translateX = interpolate(cycleFrame, [0, 45], [1200, -200], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        });

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              top: line.y,
              left: 0,
              width: `${line.width}px`,
              height: "1px",
              backgroundColor: `rgba(255, 107, 0, ${line.opacity})`,
              transform: `translateX(${translateX}px)`,
              zIndex: 3,
            }}
          />
        );
      })}

      {/* Bottom power strip */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "6px",
          background: "linear-gradient(90deg, #ff3300, #ff6b00)",
          zIndex: 10,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
